import { applyMiddleware, createStore, combineReducers } from "redux";
import { asyncMiddleware } from "./middleware/async";
import { logger } from "./middleware/logger";
import { composeWithDevTools } from "redux-devtools-extension";

import commonBank, { CommonBankState } from "src/services/reducer/bank";
import commonUser, { CommonUserState } from "src/services/reducer/user";
import commonTrial, { CommonTrialState } from "src/services/reducer/trial";

export type Action = {
  type: string;
  payload?: any;
};

export type AppState = {
  commonBank: CommonBankState;
  commonUser: CommonUserState;
  commonTrial: CommonTrialState;
};

const rootReducer = combineReducers({
  commonBank,
  commonUser,
  commonTrial
});
const middleware = applyMiddleware(asyncMiddleware, logger);
const composeEnhancers = composeWithDevTools({ trace: process.env.NODE_ENV === "development" });

const store = createStore(rootReducer, composeEnhancers(middleware));

export default store;
